/*
 * Registers the Blueprint page. Same shape as Live and Connect: `PageBlueprint`,
 * `pluginId: 'app'`, `oss_apps/backstage` untouched.
 */
import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';

export const BLUEPRINT_PATH = '/blueprint';

const blueprintPage = PageBlueprint.make({
  name: 'stackschematic-blueprint',
  params: {
    path: BLUEPRINT_PATH,
    loader: async () => {
      const { BlueprintPage } = await import('./BlueprintPage');
      return <BlueprintPage />;
    },
  },
});

export const stackSchematicBlueprintModule = createFrontendModule({
  pluginId: 'app',
  extensions: [blueprintPage],
});
